import {
  ANNOUNCEMENT_CHANNEL_LABELS,
  AnnouncementChannel,
} from '../enums/announcement-channel.enum';
import {
  ANNOUNCEMENT_CONFIRMATION_REQUIREMENT_LABELS,
  AnnouncementConfirmationRequirement,
} from '../enums/announcement-confirmation-requirement.enum';
import {
  ANNOUNCEMENT_RECIPIENT_TYPE_LABELS,
  AnnouncementRecipientType,
} from '../enums/announcement-recipient-type.enum';
import {
  ANNOUNCEMENT_STATUS_LABELS,
  AnnouncementStatus,
} from '../enums/announcement-status.enum';

export const ANNOUNCEMENT_CHANNEL_OPTIONS = [
  {
    label: ANNOUNCEMENT_CHANNEL_LABELS[AnnouncementChannel.SYSTEM],
    value: AnnouncementChannel.SYSTEM,
  },
  {
    label: ANNOUNCEMENT_CHANNEL_LABELS[AnnouncementChannel.EMAIL],
    value: AnnouncementChannel.EMAIL,
  },
  {
    label: ANNOUNCEMENT_CHANNEL_LABELS[AnnouncementChannel.SYSTEM_I_EMAIL],
    value: AnnouncementChannel.SYSTEM_I_EMAIL,
  },
];

export const ANNOUNCEMENT_CONFIRMATION_OPTIONS = [
  {
    label:
      ANNOUNCEMENT_CONFIRMATION_REQUIREMENT_LABELS[
        AnnouncementConfirmationRequirement.TAK
      ],
    value: AnnouncementConfirmationRequirement.TAK,
  },
  {
    label:
      ANNOUNCEMENT_CONFIRMATION_REQUIREMENT_LABELS[
        AnnouncementConfirmationRequirement.NIE
      ],
    value: AnnouncementConfirmationRequirement.NIE,
  },
];

export const ANNOUNCEMENT_RECIPIENT_TYPE_OPTIONS = [
  {
    label:
      ANNOUNCEMENT_RECIPIENT_TYPE_LABELS[AnnouncementRecipientType.WSZYSCY],
    value: AnnouncementRecipientType.WSZYSCY,
  },
  {
    label:
      ANNOUNCEMENT_RECIPIENT_TYPE_LABELS[
        AnnouncementRecipientType.INDYWIDUALNY
      ],
    value: AnnouncementRecipientType.INDYWIDUALNY,
  },
  {
    label:
      ANNOUNCEMENT_RECIPIENT_TYPE_LABELS[AnnouncementRecipientType.WNIOSEK],
    value: AnnouncementRecipientType.WNIOSEK,
  },
];

export const ANNOUNCEMENT_STATUS_OPTIONS = [
  {
    label: ANNOUNCEMENT_STATUS_LABELS[AnnouncementStatus.ROBOCZY],
    value: AnnouncementStatus.ROBOCZY,
  },
  {
    label: ANNOUNCEMENT_STATUS_LABELS[AnnouncementStatus.OPUBLIKOWANY],
    value: AnnouncementStatus.OPUBLIKOWANY,
  },
  {
    label: ANNOUNCEMENT_STATUS_LABELS[AnnouncementStatus.BLAD],
    value: AnnouncementStatus.BLAD,
  },
  {
    label: ANNOUNCEMENT_STATUS_LABELS[AnnouncementStatus.ARCHIWALNY],
    value: AnnouncementStatus.ARCHIWALNY,
  },
];
